'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlotTube3dIcon = function PlotTube3dIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 32 32' }, props),
        _react2.default.createElement('path', { d: 'M1.313 32h4c.75 0 1.375-.625 1.375-1.313V19.999c0-.75-.625-1.313-1.375-1.313h-4A1.32 1.32 0 0 0 0 19.999v10.688C0 31.375.625 32 1.313 32zm1.375-2.687v-8h1.313v8zM20 6.688h10.688c.688 0 1.313-.625 1.313-1.375v-4C32.001.625 31.376 0 30.688 0H20a1.32 1.32 0 0 0-1.313 1.313v4c0 .75.563 1.375 1.313 1.375zm1.313-4h8v1.313h-8zM20 5.313v9c0 3.75-1.938 5.688-5.5 5.688H5.312c-.688 0-1.313.625-1.313 1.313v8c0 .75.625 1.375 1.313 1.375H14.5c8.75 0 16.188-7.563 16.188-16.375v-9c0-.688-.625-1.313-1.375-1.313h-8c-.688 0-1.313.625-1.313 1.313zm2.688 1.375h5.313v7.625c0 7.375-6.188 13.688-13.5 13.688H6.688v-5.313h7.813c5 0 8.188-3.125 8.188-8.375z' })
    );
};

exports.default = PlotTube3dIcon;